{% block acris_faq_document_form %}
    <div class="acris-faq-document-form" :class="{ 'is--disabled': disabled }">
        {% block acris_faq_document_form_upload %}
            <sw-upload-listener
                v-if="!isLoading"
                :uploadTag="acrisUploadTag"
                autoUpload
                @media-upload-finish="successfulUpload"
                @media-upload-fail="onUploadFailed">
            </sw-upload-listener>
            <acris-faq-document-upload
                    v-if="!isLoading"
                    :uploadTag="acrisUploadTag"
                    variant="regular"
                    :scrollTarget="$parent.$el"
                    :defaultFolder="faqDocumentsEntityName"
                    @media-upload-sidebar-open="onOpenMedia">
            </acris-faq-document-upload>
        {% endblock %}

        {% block acris_faq_document_form_grid %}
            <div v-if="!isLoading"
                 class="acris-faq-document-form__grid acris-faq-document-form__column"
                 :style="gridAutoRows">
                {%  block acris_faq_document_form_grid_items %}
                    <acris-faq-document
                        v-for="documentItem in documentItems"
                        :key="documentItem.id"
                        :isPlaceholder="documentItem.isPlaceholder"
                        :mediaId="documentItem.mediaId"
                        v-draggable="{ dragGroup: 'product-media', data: documentItem, onDragEnter: onDocumentItemDragSort }"
                        v-droppable="{ dragGroup: 'product-media', data: documentItem }"
                        @acris-faq-document-delete="removeFile(documentItem)"
                        @acris-faq-document-edit="editFile(documentItem)">
                    </acris-faq-document>
                {% endblock %}
            </div>
            <sw-loader v-else></sw-loader>
        {% endblock %}

        {% block acris_faq_document_form_edit_modal %}
            <acris-edit-document-modal v-if="displayEditDocument"
                                          :documentItem="editDocumentItem"
                                          @modal-save="onEditDocumentSave"
                                          @modal-close="onEditDocumentClose">
            </acris-edit-document-modal>
        {% endblock %}
    </div>
{% endblock %}
